import * as Swiper from 'swiper/dist/js/swiper.js'; 

export default class imgTextSlider {
    constructor() {
        this.container = document.querySelector('.cp-slider-image-text');
        if (this.container === null) return;

        this.slider = document.querySelector('.js-slider-image-text');

        this.initSlider();

    }

    initSlider(slider) {
        new Swiper(this.slider, {
            slidesPerView: 'auto',
            slideClass: 'item',
            navigation: {
                nextEl: '.js-img-text-button-next',
                prevEl: '.js-img-text-button-prev',
            },
            pagination: {
                el: '.img-text-swiper-pagination',
                type: 'bullets',
                bulletClass: 'swiper-img-text-bullet',
                bulletActiveClass: '-current',
                clickable: true,
            },
            
        });
    }
}
